import PropTypes from 'prop-types';
import Link from '@activebrands/core-web/components/Link';
import { styled } from '@activebrands/core-web/libs/styletron';
import { getFocusRingStyles } from '@activebrands/core-web/utils/style-functions/get-focus-styles';
import LogotypeIcon from 'components/icons/LogotypeIcon';

const LogotypeLink = styled(Link, {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    ...getFocusRingStyles(),
});

// TODO: Add title label to CMS
const Logotype = ({ $style = {}, width, ...rest }) => (
    <LogotypeLink $style={$style} {...rest} title="Johaug" aria-label="Johaug" to="/">
        <LogotypeIcon color="currentColor" width={width} />
    </LogotypeLink>
);

Logotype.propTypes = {
    $style: PropTypes.object,
    width: PropTypes.string,
};

export default Logotype;
